import { ref } from "vue";
import { defineStore } from "pinia";

export const useDsNavigationLoaderStore = defineStore(
  "ds-navigation-loader",
  () => {
    const enabled = ref<boolean>(false);

    const enable = (): void => {
      enabled.value = true;
    };

    const disable = (): void => {
      enabled.value = false;
    };

    const isEnabled = (): boolean => {
      return enabled.value;
    };

    return {
      enabled,
      enable,
      disable,
      isEnabled,
    };
  }
);
